import { render, staticRenderFns } from "./addInspectionPoint.vue?vue&type=template&id=37549d8a&scoped=true"
import script from "./addInspectionPoint.vue?vue&type=script&lang=js"
export * from "./addInspectionPoint.vue?vue&type=script&lang=js"
import style0 from "./addInspectionPoint.vue?vue&type=style&index=0&id=37549d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37549d8a",
  null
  
)

export default component.exports